var _path, _g, _path2, _path3, _path4, _path5, _g2, _path6, _rect, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskCompleteIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 197,
    viewBox: "0 0 221 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5170_5996",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 197
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5104",
    d: "M71 196.5L39 176.5L0 22.5L159.5 0L192.5 183L71 196.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5170_5996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 5102",
    filter: "url(#filter0_d_5170_5996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    fill: "url(#paint0_linear_5170_5996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    stroke: "white"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5103",
    d: "M67.5 194L41.5 178L57.4875 174.909C61.4424 174.145 65.225 176.868 65.7552 180.861L67.5 194Z",
    fill: "#C7D2F6",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5107 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.967 48.9806C126.253 51.171 124.71 53.1793 122.52 53.4661L38.5198 64.4661C36.3294 64.7529 34.3212 63.2098 34.0343 61.0193C33.7475 58.8289 35.2906 56.8207 37.4811 56.5338L121.481 45.5338C123.672 45.247 125.68 46.7901 125.967 48.9806Z",
    fill: "url(#paint1_linear_5170_5996)",
    fillOpacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5108 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.464 71.9605C143.762 74.1494 142.229 76.1655 140.04 76.4634L44.54 89.4634C42.3511 89.7614 40.335 88.2285 40.037 86.0395C39.7391 83.8506 41.272 81.8345 43.4609 81.5365L138.961 68.5365C141.15 68.2386 143.166 69.7715 143.464 71.9605Z",
    fill: "url(#paint2_linear_5170_5996)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5110 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.966 96.9781C130.254 99.1684 128.713 101.178 126.522 101.466L50.5223 111.466C48.332 111.754 46.3228 110.212 46.0346 108.022C45.7464 105.832 47.2884 103.822 49.4786 103.534L125.479 93.5341C127.669 93.246 129.678 94.7879 129.966 96.9781Z",
    fill: "url(#paint3_linear_5170_5996)",
    fillOpacity: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2618"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 128,
    y: 93.5,
    width: 80,
    height: 82
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5170_5996_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 247",
    filter: "url(#filter1_d_5170_5996)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133.5,
    r: 36,
    fill: "url(#paint4_linear_5170_5996)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5066 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.283 120.847C187.748 122.108 187.914 124.318 186.653 125.783L166.863 148.783C166.22 149.53 165.291 149.972 164.305 149.999C163.319 150.026 162.368 149.635 161.685 148.923L149.475 136.2C148.136 134.805 148.182 132.59 149.577 131.251C150.971 129.913 153.187 129.958 154.525 131.353L164.069 141.298L181.347 121.217C182.608 119.752 184.818 119.586 186.283 120.847Z",
    fill: "#4C95FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6297",
    x: 213.428,
    y: 69.5,
    width: 9,
    height: 28,
    rx: 4.5,
    transform: "rotate(33.4342 213.428 69.5)",
    fill: "url(#paint5_linear_5170_5996)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 6298",
    x: 193.002,
    y: 60.4531,
    width: 9,
    height: 28,
    rx: 4.5,
    transform: "rotate(15.5131 193.002 60.4531)",
    fill: "url(#paint6_linear_5170_5996)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5170_5996",
    x: 8.87109,
    y: 12.7534,
    width: 174.826,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_5996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_5996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5170_5996",
    x: 128,
    y: 93.5,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5170_5996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5170_5996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5170_5996_clip_path",
    transform: "translate(-128 -93.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133.5,
    r: 36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5170_5996",
    x1: 96.25,
    y1: 16.5,
    x2: 96.25,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5170_5996",
    x1: 146,
    y1: 47.9999,
    x2: 38.5005,
    y2: 57.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5170_5996",
    x1: 150,
    y1: 72.5,
    x2: 44.0005,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5170_5996",
    x1: 140,
    y1: 90,
    x2: 46.0005,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5170_5996",
    x1: 132,
    y1: 127.5,
    x2: 208.5,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5170_5996",
    x1: 217.928,
    y1: 69.5,
    x2: 217.928,
    y2: 97.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5170_5996",
    x1: 197.502,
    y1: 60.4531,
    x2: 197.502,
    y2: 88.4531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskCompleteIllustration);
export default __webpack_public_path__ + "static/media/taskCompleteIllustration.fe710f48b3ce84e8f7890d071330e69f.svg";
export { ForwardRef as ReactComponent };